import {
  Pipe,
  PipeTransform,
} from '@angular/core';
import {IDeputy} from '../../models/deputy.model';

@Pipe({
  name: 'deputyName',
})
export class DeputyNamePipe implements PipeTransform {

  transform(deputy: IDeputy | null): string {
    if (!deputy) {
      return '';
    }
    const fullName = `${deputy.firstName ?? ''} ${deputy.lastName ?? ''}`;
    return fullName.trim() || (deputy.email ?? '');
  }

}
